module.exports = __webpack_public_path__ + "img/mx.a6f54348.png";